import React from 'react';  // import the React library
import { BrowserRouter as Router, Route, NavLink, Switch } from 'react-router-dom'; 
import '../App.css'; // import your CSS file
import DBHPic from './daddyAfula.png';
import About from '../mainPageComponents/aboutDBH';
 
const Pic = {
    borderRadius: '60%',
    height: '5em',
}

const Link = {
    textDecoration: 'none'
}

const Text = {
    fontSize: '1.6em',
    marginRight: '75%',
    paddingBottom: '.5%',
    color: 'black',
}

function BioLine(props) {
    return (
        <>
<Router>
    <Switch>
    <Route path="/about" exact component={About} />
    </Switch>
</Router>


<NavLink to="../about" style={Link}>
<img src={DBHPic} style={Pic} alt="David Ben Horin" />
<p style={Text}>By David Ben Horin
</p>
</NavLink>
</>
        );
    }
  
  export default BioLine;
  